import { useEffect, useState } from "react";
import { useIsMutating, useIsFetching } from "@tanstack/react-query";
import LoaderSpinner from "../components/common/LoaderSpinner"; // adjust path if needed

const SLOW_THRESHOLD = 1000; // 2 seconds

export default function SlowLoader() {
  const mutating = useIsMutating({ predicate: (mutation) => !mutation.options?.meta?.silent });
  const fetching = useIsFetching();
  const isBusy = mutating ;

  const [show, setShow] = useState(false);

  useEffect(() => {
    let timer;

    if (isBusy > 0) {
      timer = setTimeout(() => {
        setShow(true);
      }, SLOW_THRESHOLD);
    } else {
      setShow(false);
    }

    return () => clearTimeout(timer);
  }, [isBusy]);

  if (!show) return null;

    return (
    <div className="fixed inset-0 flex items-center justify-center z-[2000] pointer-events-none">
        <LoaderSpinner
            size="sm"
            overlay={false}
            showLogo={false}
            text="Processing Action..."
        />
    </div>
    );
}